import { useEffect, useState } from 'react';
import {
	createBrowserRouter,
	Navigate,
	RouterProvider,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import { HomeView } from './home/Home';
import { CollectionView } from './collection/Collection';
import { useAuth } from '../../views/home/auth/Authentication.hooks';
import { IssueView } from '../../views/issue/Issue';
import Drafts from '../../views/drafts/Drafts';
import Preview from '../../views/preview/Preview';
import Favorite from '../../views/favorite/Favorite';
import config from '../../config';

import './App.css';
import { TemplateMorningstar } from '../../config.type';
import { useTrackingInstallion } from '../../tracking/Tracking.hooks';

function App() {
	const basename = config?.build?.subdirectory
		? config.build.subdirectory
		: undefined;
	const [router, setRouter] = useState<any>(null);
	useTrackingInstallion();
	const routes = [
		{
			path: '/',
			element: <Home />,
		},
		{
			path: '/issues',
			element: <IssueView />,
		},
		{
			path: '/preview/:id',
			element: <Preview />,
		},
		{
			path: '/issues/:id',
			element: <AuthIssue />,
		},
		{
			path: '/collections/:id',
			element: <AuthCollection />,
		},
		{
			path: '/issues/:id/:articleId',
			element: <AuthIssue />,
		},
	];

	if (config?.app?.admin) {
		routes.push({
			path: '/drafts',
			element: <Drafts />,
		});
	}

	useEffect(() => {
		const template = config.app.template as TemplateMorningstar;
		if (config.app.favorite) {
			routes.push({
				path: '/favorite/:id',
				element: <Favorite />,
			});
		}
		if (config.app.template?.type === 'poets') {
			if (template?.config) {
				const { skipTOC } = template.config;
				if (!skipTOC) {
					routes.push({
						path: '/preview/:id',
						element: <Preview />,
					});
				}
			}
		}
		routes.push({
			path: '*',
			element: <Navigate to="/" replace />,
		});
		const r = createBrowserRouter(routes, {
			basename,
		});
		setRouter(r);
	}, []);

	if (!router) {
		return null;
	}

	const classNames = ['App'];
	if (config.app.contentProtection) {
		// classNames.push('content-protection');
	}

	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

function Home() {
	useAuth({ redirect: false });
	return (
		<>
			<HomeView />
		</>
	);
}

function AuthIssue() {
	useAuth({ redirect: true });
	return (
		<>
			<IssueView />
		</>
	);
}

function AuthCollection() {
	useAuth({ redirect: true });
	return (
		<>
			<CollectionView />
		</>
	);
}

export default App;
